import React, { useState, useEffect } from "react";
import UserModal from "./UserModal";
import { motion } from "framer-motion";
import {
  Search,
  Plus,
  Building2,
  ScrollText,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

//import { getCommodityList,createCommodity,UpdateCommodity,DeleteCommodity } from '@/redux/Masters/commodity/actions';
import {
  GetClauseList,
  CreateClauses,
  UpdateClauses,
  DeleteClauses,
} from "@/redux/Masters/clause/actions";

import { callLoader } from "@/redux/Loader/actions";
import { validateForm } from "../ui/useFormValidation";
import { showToast } from "@/redux/Toast/actions";
import Pagination from "@/pages/PortPlace/Pagination";
import { DataTable } from "../ui/table";
import { getUsersColumns } from "./Userhelper";
import Swal from "sweetalert2";


const MaintainUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const dispatch = useDispatch();
  const [recordsPerPage, setRecordPerPage] = useState(10);
  const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

  const initialCommodityForm = {
    id: "0",
    createdBy: authUser.id,
    modifyBy: authUser.id,
    countryId: authUser.companyId,
  };
  const [formData, setFormData] = useState(initialCommodityForm);
  const [errors, setErrors] = useState({});

  const [searchText, setSearchText] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("");

  const { clauseList, pagination } = useSelector((state) => state.clause);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleDateError = (fieldName, hasError) => {};

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value, // YYYY-MM-DD
    }));
  };

  useEffect(() => {
    //_getList(1);
  }, [searchText, recordsPerPage, selectedLetter]);

  const handlePrevious = () => {
    if (currentPage > 1) _getList(currentPage - 1);
  };

  const handleNext = () => {
    if (pagination?.nextPage > 0) _getList(pagination.nextPage);
  };
   const handleGoto = (page) => {
    //_getList(page);
  };

  const _getList = async (page = 1) => {
    setCurrentPage(page);
    dispatch(callLoader(1)); // optional loader

    try {
      const payload = {
        IPageNo: page,
        IPageRecords: recordsPerPage,
        searchKeyward: searchText || "",
      };

    
      await dispatch(GetClauseList(payload));

    } finally {
      dispatch(callLoader(0));
    }
  };
  const validationConfig = {
    Office: { required: true, label: "Office" },
    Profitcenter: { required: true, label: "Profit Center" },
    Role: { required: true, label: "Role" },
    firstname: { required: true, label: "First Name" },
    lastname: { required: true, label: "Last Name" },
    phone: { required: true, label: "Phone" },
    Email: { required: true, label: "Email" },
    Userid: { required: true, label: "User ID" },
    Password: { required: true, label: "Password" },
    passexpiry: { required: true, label: "Pass Expiry" },
    loadingpage: { required: true, label: "Landing Page" },
  };

  //-- Form Click Events

  const handleAddNew = () => {
    setFormData(initialCommodityForm);
    //setFormData(null);
    setOpenModal(true);
  };

  // Save Handler
  const handleSaveCommodity = async () => {
    debugger;
    const validationErrors = validateForm({
      data: formData,
      rules: validationConfig,
    });

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      dispatch(callLoader(1));

      const payload = {
        TotalRows: 0,
        RowNum: 0,

        ClauseTypeDescriptionID:
          Number(formData.id) === 0 ? 0 : Number(formData.id),

        ModuleType: "RQ",

        ClauseTypeID: Number(formData.clauseTypeId),

        ClauseDescription: formData.clauseDescription || "",

        IsAppliedUniversal: false,
        IsActive: false,

        CreatedDate: null,
        CreatedBy: "", // authUser.id,

        ModifiedDate: null,
        ModifiedBy: "", //authUser.id,

        ModuleGroup: 0,
        ClausesCategoryTypeID: Number(formData.clausesCategoryTypeId) || 0,
        ClauseType_MasterID: 0,

        ClauseType: formData.clauseType || "",
        ClauseType_IsActive: false,
        ClauseType_CreatedDate: null,
        ClauseType_ModifiedDate: null,

        ClauseCategoryTypeID: Number(formData.clausesCategoryTypeId) || 0,

        ClausesCategoryType: formData.clausesCategoryType || "",
        ClauseCategory_IsActive: false,
        ClauseCategory_CreatedOn: null,
        ClauseCategory_CreatedBy: "", //authUser.id
      };

    //   if (Number(formData.id) === 0) {
    //     const res = await CreateClauses(payload);
    //     if (res?.statuscode === 200 || res?.statuscode === 201) {
    //       dispatch(showToast("User saved successfully", "success", true));
    //     }
    //   } else {
    //     const res = await UpdateClauses(payload);
    //     if (res?.statuscode === 200 || res?.statuscode === 201) {
    //       dispatch(showToast("User updated successfully", "success", true));
    //     }
    //   }

      setTimeout(() => {
        setOpenModal(false);
      }, 500);
      _getList(currentPage);
    } catch (err) {
      //toast.error("Failed to save User");
      dispatch(showToast("Failed to save User", "error"));
    } finally {
      dispatch(callLoader(0));
    }
  };

  // Edit Detail
  const handleEdit = (row) => {
    console.log("Edit Row:", row);

    setFormData({
      id: row?.ClauseTypeDescriptionID?.toString() || "0",
      clausesCategoryTypeId: row?.ClausesCategoryTypeID?.toString() || "0",
      clauseTypeId: row?.ClauseTypeID?.toString() || "0",
      clauseDescription: row?.ClauseDescription || "",
      isAppliedUniversal: row?.IsAppliedUniversal ?? false,
      isActive: row?.IsActive ?? true,
      createdBy: "", //row?.CreatedBy || authUser.id,
      modifyBy: "", //authUser.id,
    });

    setOpenModal(true);
  };

  const handleDelete = async (payload) => {
    const result = await Swal.fire({
          title: "Are you sure?",
          text: `This record will be ${payload?.IsActive?"inactive":"active"}.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, ${payload?.IsActive?"inactive":"active"} it`,
          cancelButtonText: "Cancel",
          confirmButtonColor: payload?.IsActive?"#d33":"#15803d",
          cancelButtonColor: "#3085d6",
        });
    
        if (!result.isConfirmed) return;
    const finalPayload = {
      ClauseTypeDescriptionID: Number(payload.ClauseTypeDescriptionID),
      modifyBy: "", //authUser.id
    };
    const updateDetails = await DeleteClauses(finalPayload);
    if (
      updateDetails?.statuscode === 201 ||
      updateDetails?.statuscode === 200
    ) {
      //toast.success("Record Active/Inactive successfully");
      dispatch(showToast("User  updated successfully", "success"));
      _getList(1);
    }
    _getList(1);
  };

  const filteredList = clauseList.filter((item) => {
    const search = searchText.toLowerCase();

    return (
      item?.ClauseType?.toLowerCase().includes(search) ||
      item?.ClauseDescription?.toLowerCase().includes(search)
    );
  });

  const handlers = {
    handleEdit,
    handleDelete,
  };

  const columns = getUsersColumns(handlers);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-slate-50 dark:bg-slate-900 p-6"
    >
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl flex items-center justify-center">
              <ScrollText className="w-6 h-6 text-cyan-600 dark:text-cyan-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800 dark:text-white">
                Maintain Users
              </h1>
              {/* <p className="text-sm text-slate-500 dark:text-slate-400">Manage shipping terms, INCOTERMS, and standard clauses</p> */}
            </div>
          </div>
          <button
            onClick={() => handleAddNew()}
            data-testid="add-User-btn"
            className="flex items-center gap-2 px-4 py-2.5 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl font-medium transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add New User
          </button>
        </div>

        {/* Search */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-4 mb-6">
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              placeholder="Search by User name ..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/20"
            />
          </div>
        </div>

        {/* Table */}

        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
          <DataTable
            data={filteredList || []}
            columns={columns}
            trClass="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700/30"
            thClass="px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider"
            tdClass="px-4 py-4 text-sm text-slate-600 dark:text-slate-400"
            htrClass="bg-gradient-to-r from-slate-700 to-slate-800 text-white"
            loading={false}
            Icon={Building2}
            emptyText="No User found"
            isAplyingFilter={!!searchText}
            resetFilters={() => {
              setSearchText("");
              setSelectedLetter("ALL");
            }}
          />
        </div>

        {/* Pagination */}
        {clauseList.length > 0 && (
          <Pagination
            currentPage={currentPage}
            nextPage={pagination?.nextPage}
            recordsPerPage={recordsPerPage}
            setRecordsPerPage={setRecordPerPage}
            onPrevious={handlePrevious}
            onNext={handleNext}
            totalRecord={pagination?.totalRecord}
            handleGoto={handleGoto}
          />
        )}
      </div>
      {/* ✅ Modal (CORRECT PLACE) */}
      <UserModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setSelectedVessel(null);
          setFormData(initialCommodityForm);
          setErrors({});
        }}
        formData={formData}
        errors={errors}
        handleInputChange={handleInputChange}
        handleDateError={handleDateError}
        handleDateChange={handleDateChange}
        onSave={handleSaveCommodity}
        editData={selectedVessel}
      />
    </motion.div>
  );
};

export default MaintainUsers;
